import { useTranslator } from "@eo-locale/react";

import { useRouter } from "next/router";

import { useMemo, useState } from "react";

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Stack,
  Flex,
  HTMLWrapper
} from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";

import useEmbeds from "@/hooks/useEmbeds";

import SurveyResults from "./results";
import usePinned from "@/hooks/usePinned";
import { getQuantifiableQuestions } from "@/helpers/survey";
import useUser from "@/hooks/useUser";

const SurveyResponse = () => {
  const router = useRouter();
  const { isEmbed } = useEmbeds();
  const { isPinned } = usePinned();
  const { translate } = useTranslator();
  const [showResponses, setShowResponses] = useState(false);
  const survey = useAppSelector((state) => state.survey);
  const { project } = useAppSelector((state) => state.project);
  const { isPreviewUser } = useUser();

  const allQuantifidQuestions = useMemo(
    () => getQuantifiableQuestions(survey),
    [survey]
  );

  const { showResults, thanksMsg } = survey.survey;
  const { visibilityMode } = project;

  const showResponseNode = () => {
    if (!showResults || !allQuantifidQuestions.length || isPreviewUser)
      return null;

    const viewResponsesButton = () => (
      <Button
        variant="primary"
        size={{ base: "lg", lg: "md" }}
        onClick={() => setShowResponses(true)}
      >
        {translate("survey.viewResponses")}
      </Button>
    );

    if (isEmbed) {
      if (visibilityMode === "Public") return viewResponsesButton();
    } else return viewResponsesButton();
  };

  const successNode = () => {
    return (
      <>
        <Alert
          p={4}
          status="success"
          textAlign="center"
          justifyContent="center"
          flexDirection="column"
        >
          <AlertIcon m="auto" boxSize={10} />
          {thanksMsg.trim() ? (
            <AlertDescription mt={4} width="100%" maxWidth="md">
              <HTMLWrapper html={thanksMsg} />
            </AlertDescription>
          ) : (
            <AlertTitle mt={4} fontSize="lg">
              {translate("survey.thanksForTakingSurvey")}
            </AlertTitle>
          )}
        </Alert>
        <Stack
          mt={{ base: 9, md: 12 }}
          direction={{ sm: "column" }}
          width={{ md: "auto", sm: "full" }}
          alignSelf={{ md: "center", sm: "flex-start" }}
        >
          {!isEmbed && !isPinned && (
            <Button
              variant="secondary"
              size={{ base: "lg", lg: "md" }}
              onClick={() => router.push(`/${router.query?.projectId}`)}
            >
              {translate("survey.backToProjectPage")}
            </Button>
          )}
          {showResponseNode()}
        </Stack>
      </>
    );
  };

  return (
    <Flex
      flexDirection="column"
      justify={{ md: "start", sm: "space-between" }}
      minHeight={{ md: "auto", sm: "calc(100vh - 250px)" }}
    >
      {showResponses ? <SurveyResults /> : successNode()}
    </Flex>
  );
};

export default SurveyResponse;
